export const ENGLISH_SUFFICE = ['', 'k', 'M', 'B', 'T']
export const KOREAN_SUFFICE = ['', '만', '억', '조', '경']

export const SMALL_BALANCE_TO_HIDE = 5
